import "./styles/globals.css";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { bootObservability } from "./observability";

// Centralized logging — wire sinks once at app startup (SOLID/DIP).
bootObservability();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");
const root = ReactDOM.createRoot(rootEl);

const render = () => {
  root.render(
    <React.StrictMode>
      <FluentProvider theme={webLightTheme}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </FluentProvider>
    </React.StrictMode>,
  );
};

// Initialize Office.js if available, otherwise render directly (dev mode)
if (typeof Office !== "undefined" && Office.onReady) {
  Office.onReady(() => render());
} else {
  render();
}
